import { HiX } from "react-icons/hi";
import { CustomLabel, CustomInput, CustomSelect, CustomButton } from "../../../components/FormFields";
import { EMPLOYMENT_TYPES } from "../../../data/employeeCategories";

export default function CategoryForm({ closeForm, initialData, onSave }) {
  function handleSubmit(e) {
    e.preventDefault();
    const fd = new FormData(e.target);
    onSave({
      id:             initialData?.id ?? Date.now(),
      name:           fd.get("name"),
      description:    fd.get("description"),
      employmentType: fd.get("employmentType"),
    });
    closeForm();
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative w-full max-w-md rounded-2xl bg-white shadow-2xl dark:bg-gray-800">

        <div className="flex items-center justify-between rounded-t-2xl bg-purple-600 px-6 py-4">
          <h3 className="text-lg font-semibold text-white">
            {initialData ? "Edit Category" : "Create Employee Category"}
          </h3>
          <button type="button" onClick={closeForm}
            className="rounded-lg p-1.5 text-purple-200 hover:bg-purple-500 hover:text-white">
            <HiX className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4 px-6 py-6">
          <div className="flex flex-col gap-1.5">
            <CustomLabel htmlFor="name">Category Name</CustomLabel>
            <CustomInput
              id="name" name="name"
              defaultValue={initialData?.name}
              placeholder="e.g. Senior Staff"
              required
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <CustomLabel htmlFor="description">Description</CustomLabel>
            <CustomInput
              id="description" name="description"
              defaultValue={initialData?.description}
              placeholder="e.g. Employees with 5+ years of service"
            />
          </div>

          <div className="flex flex-col gap-1.5">
            <CustomLabel htmlFor="employmentType">Employment Type</CustomLabel>
            <CustomSelect id="employmentType" name="employmentType" defaultValue={initialData?.employmentType ?? "Permanent"}>
              {EMPLOYMENT_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
            </CustomSelect>
          </div>

          <div className="flex justify-end gap-3 border-t border-gray-100 pt-2 dark:border-gray-700">
            <CustomButton color="gray" type="button" onClick={closeForm}>Cancel</CustomButton>
            <CustomButton color="purple" type="submit">{initialData ? "Update" : "Create"}</CustomButton>
          </div>
        </form>
      </div>
    </div>
  );
}
